import React, { useState } from 'react';
import { Row, Col, Card, Nav, Badge, Container } from 'react-bootstrap';
import Listing from 'components/Listing';
import style from './style.module.scss';
import { useTranslation } from 'react-i18next';

const ListingStatuses = ({
  statuses,
  fields,
  data,
  filters,
  stateFilters,
  handleFilterChange,
  actions
}) => {
  const { t } = useTranslation();
  const [all, setAll] = useState(true);

  const handleSelect = status_id => {
    handleFilterChange({ 
      status_id:status_id!=0?status_id:null
      , page: 1 }, true);
    if (status_id !== 0) {
      setAll(false);
    } else {
      setAll(true);
    }
  };
  let count = 0;

  return (
    <>
      <Row>
        <Col>
          <Card.Body className={style.statuses}>
            <Nav
              variant="pills"
              activeKey={stateFilters.status_id?stateFilters.status_id:0}
              onSelect={handleSelect}
            >
              {statuses.map((status, k) => {
                count += status.count;
                return (
                  <Nav.Item key={k}>
                    <Nav.Link key={k} eventKey={status.id}>
                      {t(`statuses:${status.name}`)}
                      <Badge variant="light">{status.count}</Badge>
                    </Nav.Link>
                  </Nav.Item>
                );
              })}
              <Nav.Item>
                <Nav.Link eventKey={0}>
                  {t('label:all')}
                  <Badge variant="light">{count}</Badge>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Body>
        </Col>
      </Row>
      <hr />
      <Row className="mt-4">
        <Col>
          <Listing
            {...{
              fields,
              data,
              filters,
              stateFilters,
              handleFilterChange,
              actions,
              all,
              pagination:data.pagination
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default ListingStatuses;
